export enum ActionType {
  FINAL_APPROVAL_DETAILS_BY_PID = "FINAL_APPROVAL_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IFinalApprovalDetailsByPid {
  type: ActionType.FINAL_APPROVAL_DETAILS_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IFinalApprovalDetailsByPid | IResetReduxState;
